import Alpine from "alpinejs";
import intersect from "@alpinejs/intersect";

import vimeoPlayer from "./vimeoPlayer.js";

Alpine.plugin(intersect);

/* data components */
Alpine.data("vimeoPlayer", vimeoPlayer);

/* start your engines */
window.Alpine = Alpine;
Alpine.start();
